import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
    selector: 'emt-dropdown-v3',
    templateUrl: './dropdown-v3.component.html',
    styleUrls: ['./dropdown-v3.component.scss'],
    imports: [NgSelectComponent],
})
export class DropdownV3Component {
  @Input() placeholder: string;
  @Input() options: any;
  @Output() valueChanged = new EventEmitter();
}
